// http-error.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IFrameEventManagerService } from '../iframe-event-manager.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private iframeEventService: IFrameEventManagerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!req.url.includes('weather-events')) {
          console.error('HTTP Error:', error);
          this.iframeEventService.sendStatus(error.status?.toString()); // on envoie le status de l'erreur à l'iframe
        }
        return throwError(() => error); // on re-propage l'erreur
      })
    );
  }
}
